export const isPosIncludedInRebookE2eFlows = (pointOfSale?: string): boolean => {
  if (!pointOfSale) return true;

  return !window.__GLOBAL_CONTEXT__?.rebookExcludedCountries?.includes(pointOfSale.toLowerCase());
};
